import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './UserPassPage.module.scss';
import clsx from 'clsx';
import ProfileBlock from '../../components/ProfileBlock/ProfileBlock';
import Layout from '../../components/Layout/Layout';
import Row from '../../components/Row/Row';
import Block from '../../components/Block/Block';
import { gameUserList } from '../../redux/actions/game/gameUserList';
import UserPassItem from '../../components/UserPassItem/UserPassItem';
const UserPassPage = () => {
  const dispatch = useDispatch();
  const {
    gameUserList: { data: gameUserListData, loading: gameUserListLoading, error: gameUserListError },
  } = useSelector((state) => state.game);

  useEffect(() => {
    dispatch(gameUserList());
  }, []);

  return (
    <>
      <>
        <div className="wrap">
          <Block title="Пропуска" className={styles.pass}>
            <p className={styles.text}>Для каждой игры вы можете подключить только один игровой аккаунт. Но GammiPass будет работать на всех сайтах партнерах. Сменить игровой аккаунт (ID, UID и т.п.) возможно через нашу поддержку.</p>
            <div className={clsx(styles.subtitle)}>Список игр</div>
            {gameUserListData?.map((item, index) => (
              <UserPassItem {...item} index={index + 1} key={item?.id} />
            ))}
          </Block>
        </div>
      </>
    </>
  );
};

export default UserPassPage;
